import { render, staticRenderFns } from "./ProvidersTable.vue?vue&type=template&id=7fee6dd9&"
import script from "./ProvidersTable.vue?vue&type=script&lang=js&"
export * from "./ProvidersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports